export default __webpack_public_path__ + "static/concept_back-bd42b82cf21fb8faa28942b35834c589.webp";